/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import PropTypes from 'prop-types';
import Step from './step';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  toolbar: {
    backgroundColor: '#fff',
  },
}));

const Stepper = ({ allSteps, onStepCLickedCallback }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" elevation={0}>
        <Toolbar className={classes.toolbar}>
          {allSteps.map((step, index) => (
            <Step
              key={step.label}
              onStepCLickedCallback={onStepCLickedCallback}
              count={index + 1}
              label={step.label}
              active={step.active}
              completed={step.completed}
            />
          ))}
        </Toolbar>
      </AppBar>
    </div>
  );
};

Stepper.propTypes = {
  /* * Example of an object of the array     {
   * label: 'Edit Event',
   * active: false,
   * completed: true,
   * } **/
  allSteps: PropTypes.array,
  /* this is the function that is called  when a stepper is clicked . in arguments it gives the index of the item that is clicked . you can change active state accordingly then */
  onStepCLickedCallback: PropTypes.func,
};

Stepper.defaultProps = {
  allSteps: [],
  onStepCLickedCallback: undefined,
};

export default Stepper;
